/**
 * CompletionCheckbox
 * 
 * Checkbox circular reutilizável para marcar conclusão de tarefas.
 * Usado em tabelas de tarefas, acordeões e cards.
 */

import React from 'react';
import { AppIcon } from '../icons/AppIcon';

interface CompletionCheckboxProps {
    isCompleted: boolean;
    onToggle: () => void;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
};

const iconSizeClasses = {
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
    lg: 'w-3.5 h-3.5'
};

const CompletionCheckbox: React.FC<CompletionCheckboxProps> = ({
    isCompleted,
    onToggle,
    size = 'md',
    className = ''
}) => {
    return (
        <button
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                onToggle();
            }}
            className={`
                ${sizeClasses[size]} 
                rounded-full border-2 flex items-center justify-center transition-all
                ${isCompleted
                    ? 'bg-success border-success'
                    : 'border-border bg-surface hover:border-success hover:bg-success-bg'
                }
                ${className}
            `}
            title={isCompleted ? 'Reabrir tarefa' : 'Concluir tarefa'}
            aria-label={isCompleted ? 'Reabrir tarefa' : 'Concluir tarefa'}
            aria-pressed={isCompleted}
        >
            {isCompleted && (
                <AppIcon
                    name="check"
                    className={`${iconSizeClasses[size]} text-primary-foreground`}
                    strokeWidth={3}
                />
            )}
        </button>
    );
};

export default CompletionCheckbox;
